import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TemplateServiceService {


  url = environment.serverAPI9 + "/api/emailtemplates";

  url1 = environment.serverAPI4 + "/api/eavattribute";

  constructor(private http: HttpClient) { }

  getAllEmailTemplates(Page: any, size: any, sort: any): Observable<Object> {
    const requestBody = { "searchQuery": null };
    return this.http.post(`${this.url}/condition?page=${Page}&size=${size}&sort=${sort}`, requestBody);
  }

  searchAllEmailTemplates(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,

    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`;

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  getAllEmailSendDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getAllEmailSendDropDownPrimary(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown/primary`);
  }


  getEmailSendById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEmailSend(emails: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, emails);
  }

  emailTeamplateSearch(query: any, Page: any, size: any, sort: any): Observable<Object> {
    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null,
    };
    return this.http.post(`${this.url}/condition?page=${Page}&size=${size}&sort=${sort}`, requestBody);
  }


  deleteByEmailSendId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  getAllEmailByLeadId(leadId: number): Observable<Object> {
    return this.http.get(`${this.url}/lead/${leadId}`);
  }


  sendEmailMessage(leadData: any, templateId: any, fromEmailId?: any, fromEmail?: any): Observable<Response[]> {
    let queryParams = '';
    if (fromEmailId !== undefined && fromEmailId !== null) {
      queryParams = `?fromEmailId=${fromEmailId}&userMailConfigId=${fromEmailId}`;
      if (fromEmail) {
        queryParams += `&fromEmail=${fromEmail}`;
      }
    }
    return this.http.post<Response[]>(`${this.url}/new/${templateId}${queryParams}`, leadData);
  }

  getDropDown(entityTypeId: number) {
    return this.http.get(`${this.url1}/grid/${entityTypeId}`);
  }

  deleteByEmailTemplateId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/delete/${id}`);
  }

}
